import { useState } from "react";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";

import ConfirmButton from "../../common/components/ConfirmButton";

import ssnBlockingService from "../../services/ssnBlocking/services";
import { checkSsn } from "../../common/validations/ssn";
/*
import CheckIcon from '@material-ui/icons/Check';

import { Dialog, DialogTitle, DialogContent, DialogActions, Checkbox } from '@material-ui/core';
import useModal from '../hooks/modals';*/

const SsnBlocking = ({ getBlockInfo, ssnBlock, unblockSsn, blockSsn }) => {
  const [ssn, changeSsn] = useState("");
  const [reason, setReason] = useState("");

  let isBlocked;
  let isSet;

  if (
    ssnBlock.fetched &&
    ssnBlock.data.Ssn === ssn &&
    ssnBlock.data.IsBlocked
  ) {
    isBlocked = true;
    isSet = true;
  }

  if (
    ssnBlock.fetched &&
    ssnBlock.data.Ssn === ssn &&
    !ssnBlock.data.IsBlocked
  ) {
    isBlocked = false;
    isSet = true;
  }

  const error = checkSsn(ssn) != !!ssn;

  return (
    <div className="accounting-layout body-height">
      <Card>
        <CardHeader title="Check for blocked ssn's" />
        <CardContent>
          <TextField
            error={error}
            helperText={error ? "invalid ssn" : undefined}
            size="small"
            variant="outlined"
            label="Ssn"
            value={ssn}
            onChange={(e) => {
              changeSsn(e.target.value);
            }}
          />
          <Button disabled={error} onClick={() => getBlockInfo(ssn)}>
            Check ssn
          </Button>
          {ssnBlock.fetching && <CircularProgress />}
          {isSet && isBlocked && (
            <div>
              <span style={{ color: "red" }}>
                {" "}
                SSN: <strong>{ssn}</strong> is Blocked, for reason:{" "}
                {ssnBlock.data.Reason
                  ? ssnBlock.data.Reason
                  : "no reason stated"}
              </span>
              <ConfirmButton
                label="Remove blockade for user"
                action={() => {
                  unblockSsn(ssn);
                }}
              />
            </div>
          )}
          {isSet && !isBlocked && (
            <div>
              <span style={{ color: "green" }}>
                {" "}
                SSN: <strong>{ssn}</strong> is not Blocked.
              </span>
              <ConfirmButton
                label="block user"
                action={() => {
                  blockSsn(ssn, reason);
                }}
              >
                <div>
                  <TextField
                    label="reason for blocking?"
                    onChange={(e) => {
                      setReason(e.target.value);
                    }}
                  />
                </div>
              </ConfirmButton>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default ssnBlockingService(SsnBlocking);
